module.exports = ".widget-8{height:145px;overflow:hidden}.widget-8 .widget-8-chart{height:100px;width:50%;bottom:0;position:absolute;right:0;display:block}\n"